__turbopack_context__.v({
  "active": "-ua7ea_active",
  "articleGroup": "-ua7ea_articleGroup",
  "card": "-ua7ea_card",
  "container": "-ua7ea_container",
  "content": "-ua7ea_content",
  "contentContainer": "-ua7ea_contentContainer",
  "divider": "-ua7ea_divider",
  "featured": "-ua7ea_featured",
  "filter": "-ua7ea_filter",
  "gutterContent": "-ua7ea_gutterContent",
  "imageContainer": "-ua7ea_imageContainer",
  "inverse": "-ua7ea_inverse",
  "label": "-ua7ea_label",
  "readmore": "-ua7ea_readmore",
  "title": "-ua7ea_title",
});
